import React from "react";
import { FaCode, FaMobileAlt, FaServer, FaProjectDiagram } from "react-icons/fa";

function About() {
  const expertise = [
    {
      icon: FaCode,
      title: "Frontend Development",
      description:
        "I build modern web applications using React, Vue.js, and TypeScript. I create clean, responsive designs with Tailwind CSS.",
    },
    {
      icon: FaMobileAlt,
      title: "Mobile Development",
      description:
        "I create cross-platform mobile apps for iOS and Android using React Native. I manage the full process from design to publishing on app stores.",
    },
    {
      icon: FaServer,
      title: "Backend & APIs",
      description:
        "I build REST APIs with .NET Core and C#. I work with SQL databases, user authentication, and server-side logic.",
    },
    {
      icon: FaProjectDiagram,
      title: "Full-Stack Projects",
      description:
        "I handle complete projects from planning to deployment. I create technical diagrams, write clean code, use Git, and deploy to production.",
    },
  ];

  return (
    <section
      id="about"
      className="py-16 text-gray-600 dark:text-gray-300 px-10 bg-white dark:bg-[black] p-10 rounded-xl mt-10 transition-colors duration-300"
    >
      <h2 className="text-4xl text-center mb-8 text-gray-700 dark:text-gray-200">
        About Me
      </h2>
      <hr className="h-px my-8 bg-gray-400 dark:bg-gray-500 border-0" />

      {/* Lead Paragraph */}
      <div className="max-w-3xl mx-auto text-center mb-12">
        <p className="text-xl leading-relaxed text-gray-700 dark:text-gray-300">
          I'm a full-stack developer working with{" "}
          <span className="font-semibold bg-gradient-to-r from-purple-600 to-blue-500 bg-clip-text text-transparent">
            React, React Native, and .NET Core.
          </span>{" "}
          I build web applications, mobile apps, and backend APIs. I take
          projects from idea to finished product.
        </p>
      </div>

      {/* Expertise Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
        {expertise.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <div
              key={index}
              className="group p-6 bg-gray-50 dark:bg-[#0a0a0a] rounded-xl border border-gray-200 dark:border-gray-800 hover:border-purple-400 dark:hover:border-purple-600 transition-all duration-300 hover:shadow-lg"
            >
              <IconComponent className="text-3xl mb-3 text-purple-600 dark:text-purple-400 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-2 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>

      {/* Technical Highlights */}
      <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div>
            <div className="text-3xl font-bold text-purple-600 dark:text-purple-400 mb-1">
              5+
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Published Apps
            </div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-600 dark:text-purple-400 mb-1">
              10+
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Web Projects
            </div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-600 dark:text-purple-400 mb-1">
              5+
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Years Experience
            </div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-600 dark:text-purple-400 mb-1">
              100%
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Client Satisfaction
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
